import React, {Component} from 'react'
import {
  Box,
  Button,
  Flex,
  Heading,
  Spacer,
  HStack,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Container,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure
} from '@chakra-ui/react';
import './Navigation.css'
import '../../styles/fonts.css'

function TutorialModalButton() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        variant="ghost"
        fontSize={'sm'}
        color={'#E05252'}
        fontWeight="500"
        _hover={{
          color: '#C94545',
          bg: 'transparent',
        }}
        _active={{
          bg: 'transparent',
        }}
        transition="color 0.2s"
        onClick={onOpen}
      >
        Tutorial
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(4px)" />
        <ModalContent borderRadius="xl">
          <ModalHeader fontWeight="600" fontSize="md">Tutorial Video</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <div style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
              <iframe
                src="https://www.youtube.com/embed/GgJ8jqVHeiY"
                title="How to use Writewizard"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: "8px"
                }}
              />
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

class Navigation extends Component {
  render () {
    return (
      <Box
        bg="rgba(255, 255, 255, 0.85)"
        backdropFilter="blur(12px)"
        top="0"
        position="sticky"
        zIndex="1000"
        borderBottom="1px solid"
        borderColor="#E4E4E7"
      >
        <Container maxW="2200px" px={8}>
          <Flex
            as="nav"
            alignItems="center"
            py="10px"
            width="100%"
          >
            <Box cursor="pointer">
              <Heading fontWeight="700" as="h1" fontSize="1.5em" mr="0" color="#C94545" display="inline" letterSpacing="-0.03em">Write</Heading>
              <Heading fontWeight="700" as="h1" fontSize="1.5em" ml="0" color="#E05252" display="inline" letterSpacing="-0.03em">wizard</Heading>
            </Box>
            <Spacer />
            <HStack spacing="12px">
              <TutorialModalButton />
              <UserOptions
                onRouteChange={this.props.onRouteChange}
                onLogOut={this.props.onLogOut}
                isAuthenticated={this.props.isAuthenticated}
              />
            </HStack>
          </Flex>
        </Container>
      </Box>
    )
  }
}

class UserOptions extends Component {
  render() {
    if (!this.props.isAuthenticated) {
      return (
        <Menu>
          <MenuButton
            as={Avatar}
            size='sm'
            src=''
            bg="#E05252"
            _hover={{
              cursor: 'pointer',
              opacity: '0.85'
            }}
            transition="opacity 0.2s"
          />
          <MenuList
            borderRadius="xl"
            border="1px solid"
            borderColor="#E4E4E7"
            boxShadow="0 4px 16px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)"
            py={2}
          >
            <MenuItem fontSize="md" fontWeight="500" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={() => this.props.onRouteChange('login')}>Log In</MenuItem>
            <MenuItem fontSize="md" fontWeight="500" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={() => this.props.onRouteChange('explore')}>Explore</MenuItem>
          </MenuList>
        </Menu>
      )
    }
    return (
      <Menu>
        <MenuButton
          as={Avatar}
          size='sm'
          src=''
          bg="#E05252"
          _hover={{
            cursor: 'pointer',
            opacity: '0.85'
          }}
          transition="opacity 0.2s"
        />
        <MenuList
          borderRadius="xl"
          border="1px solid"
          borderColor="#E4E4E7"
          boxShadow="0 4px 16px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)"
          py={2}
        >
          <MenuItem fontSize="md" fontWeight="500" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={() => this.props.onRouteChange('account')}>Account</MenuItem>
          <MenuItem fontSize="md" fontWeight="500" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={() => this.props.onRouteChange('index')}>My Stories</MenuItem>
          <MenuItem fontSize="md" fontWeight="500" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={() => this.props.onRouteChange('practice')}>Practice</MenuItem>
          <MenuItem fontSize="md" fontWeight="500" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={() => this.props.onRouteChange('explore')}>Explore</MenuItem>
          <MenuItem fontSize="md" fontWeight="500" color="#E05252" _hover={{ bg: '#FEF2F2' }} borderRadius="md" mx={1} onClick={this.props.onLogOut}>Sign Out</MenuItem>
        </MenuList>
      </Menu>
    )
  }
}

export default Navigation;
